export default function transformInputSelectArray(inputArray, valueProperty, labelProperty) {
    return inputArray?.map(item => ({
        "value": item[valueProperty],
        "label": item[labelProperty]
    }));
}

